"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelCodes = void 0;
var _ChannelCodes = {
    Haven: 'Haven',
    Valora: 'Valora',
    CAS: 'CAS',
    MM: 'MM',
    RMM: 'RMM',
    MMDirect: 'MMDirect',
    LifeBridge: 'LifeBridge',
    HealthBridge: 'HealthBridge'
};
exports.ChannelCodes = _ChannelCodes;
